import ProductPriceTable from '../includes/product-price-table';

hp(window).on('load', () => {
    new ProductPriceTable('.product-price-table')

    if (hp('html').attr('lang') != 'en') {
        let form = hp('#get-assist-form');

        let errorFunc = () => {
            let modal = hp('#get-assist-modal');

            form.html('')
            modal.find('.modal-footer').html('')

            modal.find('.modal-header .title').html('<p class="h2">' + getTrans(`fail.title`) + '</p>')
            modal.find('.modal-header .sub-title').text(getTrans(`fail.sub-title`))
        }

        let getTrans = (key) => {
            let trans = {
                // 'en': {
                //     'success.title': 'Дякуємо!',
                //     'success.sub-title': 'Наш менеджер зв\'яжетсья з вами',

                //     'fail.title': 'Щось пішло не так!',
                //     'fail.sub-title': 'Перепрошуємо, зараз ми не змогли прийняти заявку, спробуйте пізніше ',
                // },
                'ru': {
                    'success.title': 'Спасибо!',
                    'success.sub-title': 'Наш менеджер свяжется с Вами',

                    'fail.title': 'Щось пішло не так!',
                    'fail.sub-title': 'Перепрошуємо, зараз ми не змогли прийняти заявку, спробуйте пізніше',
                },
                'uk': {
                    'success.title': 'Дякуємо!',
                    'success.sub-title': 'Наш менеджер зв\'яжетсья з вами',

                    'fail.title': 'Что-то пошло не так!',
                    'fail.sub-title': 'Извините, сейчас мы не можем принять заявку, попробуйте позже',
                },
            };


            return trans[hp('html').attr('lang')][key];
        };

        form.on('submit', (e) => {
            e.preventDefault()

            let errorBlock = hp('#get_assist_error-block')
            let userName = form.find('#user-name')
            let userTel = form.find('#user-tel')

            errorBlock.html('')

            let data = {
                'name': userName.val(),
                'tel': userTel.val(),
                'g-recaptcha-response': getReCaptchaV3Response('get_assist_id')
            };

            let request = new XMLHttpRequest()

            request.onload = () => {
                let response = JSON.parse(request.response);

                if (!('status' in response)) {
                    errorFunc()
                    return;
                }

                if ('inputs' in response) {
                    hp(response.inputs).each((elem, index) => {
                        hp(elem).each((el, i) => {
                            let text = Object.values(el)[0][0]

                            errorBlock.append(`<div class="alert alert-danger">${text}</div>`)
                        })
                    })

                    return;
                }

                let modal = hp('#get-assist-modal');

                form.html('')
                modal.find('.modal-footer').html('')

                modal.find('.modal-header .title').html('<p class="h2">' + getTrans(`${response.status}.title`) + '</p>')
                modal.find('.modal-header .sub-title').text(getTrans(`${response.status}.sub-title`))
            }

            request.onerror = () => {
                errorFunc()
            }

            request.open('POST', '/' + hp('html').attr('lang') + '/send/get-assist')
            request.setRequestHeader('X-CSRF-TOKEN', hp('meta[name="csrf-token"]').attr('content'))
            request.overrideMimeType('application/json')
            request.setRequestHeader('Content-Type', 'application/json')
            request.send(JSON.stringify(data))
        })
    }
})
